module.exports = __webpack_public_path__ + "static/media/economics.1978c6f2.jpg";